import { Component, ContentChild, HostListener, inject, OnInit } from '@angular/core';
import { OnboardingFacade } from '@zero/onboarding/domain';
import { ButtonComponent } from '@zero/shared/ui-web-design-system';

@Component({
  template: '',
})
export abstract class BaseComponent implements OnInit {
  @ContentChild(ButtonComponent) public btn?: ButtonComponent;

  public readonly facade = inject(OnboardingFacade);

  @HostListener('window:keydown', ['$event'])
  public pressEnter(event: KeyboardEvent): void {
    event.key === 'Enter' && this.submit();
  }

  ngOnInit(): void {
    this.populateFromData();
    this.listenToSuccessfulSubmit();
  }

  protected abstract submit(): Promise<void> | void;
  protected abstract populateFromData(): void;
  protected abstract listenToSuccessfulSubmit(): void;
}
